<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="20">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="searchValue"
          />
          <Button @click="handleSearch" class="search-btn" type="primary"
            >搜索</Button
          >
        </Col>
        <Col span="4" class="search-right">
          <Button @click="showAddModal" type="primary">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="addModal"
      title="添加职位"
      footer-hide
    >
      <forms
        ref="addChild"
        :resetFlag="resetFlag"
        @on-ok="addSumit"
        @on-cancel="cancel"
      />
    </Modal>
    <Modal
      :width="modalWidth"
      :mask-closable="false"
      v-model="editModal"
      title="编辑职位"
      footer-hide
    >
      <forms
        ref="editChild"
        :resetFlag="resetFlag"
        @on-ok="editSumit"
        @on-cancel="cancel"
      />
    </Modal>
  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./form.vue";
import {
  getRoleList,
  getRoleInfo,
  addRole,
  delRole,
  editRole,
  getAllPermission,
} from "@/api/data";
export default {
  name: "role",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,

      modalWidth: 600,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      searchValue: "",
      tableLoading: true,
      columns: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        { title: "职位名称", key: "name", editable: true },
        { title: "职位代码", key: "value", editable: true },
        {
          title: "Handle",
          key: "handle",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      getAllPermission()
        .then((res) => {
          var permissionList = res.data.data.records;
          this.$refs.addChild.setData(permissionList);
          this.addModal = true;
          this.resetFlag = !this.resetFlag;
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    showEditModal(params) {
      getAllPermission()
        .then((res) => {
          var permissionList = res.data.data.records;
          this.$refs.editChild.setData(permissionList);
          getRoleInfo(params.row.id).then((res) => {
            var data = res.data.data;
            var permissions = [];
            for (var i = 0; i < data.permissions.length; i++) {
              permissions[i] = data.permissions[i].id;
            }
            data.permissions = permissions;
            this.$refs.editChild.setEditData(data);
            this.editModal = true;
          });
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    addSumit(formValidate) {
      addRole(formValidate)
        .then((res) => {
          // res
          // data {code data msg}
          // status
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    editSumit(formValidate) {
      editRole(formValidate)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      getRoleList(this.page, this.pageSize, this.searchValue).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: "提示",
        content: "<p>是否确认删除？</p>",
        onOk: () => {
          delRole(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.tableData.splice(params.index, 1);
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info("已取消");
        },
      });
      // params
      // row
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
